/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

// REACT_APP_FEDEX_FEATURE_FLAG gates the Capture UI Notes and Save & Exit features,
// plus the name/email identity gate and resume gate that ship with them. Must
// match the server's FEDEX_FEATURE_FLAG. Anything other than the literal 'true'
// (including a missing key) means OFF. CRA bakes this in at build time, so
// changing it requires rebuilding the frontend.
export const NOTES_SAVE_EXIT_ENABLED = process.env.REACT_APP_FEDEX_FEATURE_FLAG === 'true';
